//
//
//
//
//
//
//
//

export default {
  name: 'CheckboxOption',
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    // 只有多选会使用带checkbox的option，所以已选数据一定是列表
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    isSelected() {
      return this.selected.includes(this.value);
    },
  },
};
